import { EInternalPackageType, TAppState } from '../../types';
import { selectPackageInternalType } from './selectPackageInternalType';

export const selectIsPublicationSubscription = (state: TAppState): boolean => {
  const internalType = selectPackageInternalType(state);

  return [EInternalPackageType.SubscriptionPublication, EInternalPackageType.PersonalSubscriptionPublication].includes(
    internalType,
  );
};
